import { getBase64 } from "shared/src/libs/s3Lib/s3Lib"
import { bytesToMegabytes } from "shared/src/libs/statsLib/statsLib"
import { useConfigContext } from "shared/src/libs/contextLib/contextLib"
import defaultSilhouette from "../../images/defaultSilhouette.png"
import "./RecruiterPhoto.css"
import { ALLOWED_IMAGE_TYPE_STRING } from "shared/src/constants/constants"
import { Spinner } from "../shadcn/components/ui/spinner"

export function RecruiterPhoto({ recruiterPhoto, setRecruiterPhoto, disabled = false, loading = false }) {
	const { MAX_LOGO_SIZE } = useConfigContext()

	async function handleFileChange(event) {
		const file = event.target.files[0]
		if (file.size > MAX_LOGO_SIZE) {
			// eslint-disable-next-line no-template-curly-in-string
			alert(`Photo should be no bigger than ${bytesToMegabytes(MAX_LOGO_SIZE)}MB`)
			event.target.value = ""
			return
		}
		if (file != null) {
			try {
				const newPhoto = await getBase64(file)
				await setRecruiterPhoto(newPhoto) // Handle async API call
			} catch (error) {
				console.error("Failed to upload photo:", error)
				alert("Failed to upload photo. Please try again.")
				event.target.value = ""
			}
		}
	}

	return (
		<>
			<input
				type="file"
				id="recruiter-photo"
				accept={ALLOWED_IMAGE_TYPE_STRING}
				onChange={handleFileChange}
				disabled={disabled || loading}></input>
			<label
				className={`bs-label recruiterLabel ${!disabled && !loading ? "clickable" : ""}`}
				htmlFor="recruiter-photo">
				{loading ? (
					<div className="recruiter-photo-loading">
						<Spinner aria-label="Loading" />
					</div>
				) : (
					<img className="recruiterPhoto" src={recruiterPhoto ?? defaultSilhouette} alt="recruiter"></img>
				)}
			</label>
		</>
	)
}
